import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { Mutation } from 'react-apollo';
import cloneDeep from 'lodash/cloneDeep';
import './styles.css';
import gql from 'graphql-tag';

const COMPUTE = gql`
	mutation($gameID: ID!) {
		compute(gameID: $gameID) @client{
			id
			data
		}
	}
`;
const START_LOADING = gql`
  mutation {
    startLoading @client
  }
`
const STOP_LOADING = gql`
  mutation {
    stopLoading @client
  }
`
const SAVE_GAME_MUTATION = gql`
	mutation($gameID: ID!, $data: JSON!) {
		updateGame(gameID: $gameID, data: $data) {
			id
			data
		}
	}
`;

const Compute = ({ match }) => {
	return (
		<Mutation mutation={SAVE_GAME_MUTATION}>
			{(saveGameMutation, dataSave) => (
				<Mutation mutation={COMPUTE}>
					{compute => (
						<Mutation mutation={START_LOADING}>
							{startLoading => (
								<Mutation mutation={STOP_LOADING}>
									{stopLoading => (
										<div
											className="compute"
											onClick={() => {
												startLoading();
												const fragment = gql`
													fragment gameFragment on Game {
														id
														data
													}
												`;
												const game = dataSave.client.cache.readFragment({
													fragment,
													id: `Game:${match.params.gameID}`
												});
												const gameData = cloneDeep(game.data);
												saveGameMutation({
													variables: {
														gameID: match.params.gameID,
														data: gameData
													}
												}).then(() => {
													compute({
														variables: { gameID: match.params.gameID }
													})
														.then(() => {
															stopLoading();
														})
												});
											}}
										>
											<FormattedHTMLMessage id="compute" />
										</div>
									)}
								</Mutation>
							)}
						</Mutation>
					)}
				</Mutation>
			)}
		</Mutation>
	);
};

export default Compute;
